import StandardPage from "../components/layout/standardPage";
import NotFound from "../components/errors/notFound";

export default function FourZeroFour() {
    return (
        <StandardPage title={"Not Found"} padPage={true}>
            <NotFound />
        </StandardPage>
    )
}